import { useState, useCallback, useMemo } from 'react';
import { useGetDashboards } from '../fetch/useGetDashboards';
import { DashboardPageViewModel } from '../../types';
import { SaiDashboardType } from '../../../../graphQL';

export const useDashboardPageViewModel = (): DashboardPageViewModel => {
  const dashboardsResult = useGetDashboards();

  const [activeTabKey, setActiveTabKey] = useState<SaiDashboardType | null>();

  const dashboards = useMemo(
    () => (dashboardsResult.status === 'success' ? dashboardsResult.dashboards : []),
    [dashboardsResult]
  );
  const effectiveTabKey = activeTabKey || dashboards[0]?.key || '';

  const onTabChange = useCallback(
    (tabKey: string) => {
      if (dashboards.some(d => d.key === tabKey)) {
        setActiveTabKey(tabKey as SaiDashboardType);
      }
    },
    [dashboards]
  );

  if (dashboardsResult.status === 'loading') {
    return { status: 'loading' };
  }

  if (dashboardsResult.status === 'error') {
    return { status: 'error', errorMessage: dashboardsResult.error };
  }

  return {
    status: 'success',
    dashboards,
    activeTabKey: effectiveTabKey,
    onTabChange,
  };
};
